var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2354 2.60431C29.1088 3.05339 27.9139 3.34816 26.6903 3.47883C27.9648 2.79148 28.9434 1.70304 29.4042 0.40617C28.1926 1.05311 26.8671 1.50892 25.4849 1.7539C24.3589 0.674553 22.7549 0 20.9796 0C17.5709 0 14.8073 2.48672 14.8073 5.55377C14.8073 5.98913 14.8619 6.41296 14.9671 6.81955C9.83746 6.58786 5.28955 4.37682 2.24527 1.01664C1.7141 1.83691 1.40973 2.79106 1.40973 3.80875C1.40973 5.73566 2.49946 7.43552 4.15551 8.43154C3.17536 8.40392 2.21677 8.1657 1.35978 7.73679C1.35943 7.76005 1.35943 7.78332 1.35943 7.80669C1.35943 10.4976 3.48696 12.7424 6.31042 13.2526C5.40153 13.475 4.44816 13.5076 3.52315 13.3478C4.30852 15.5543 6.588 17.1599 9.28878 17.2048C7.17641 18.6944 4.515 19.5823 1.62337 19.5823C1.1251 19.5823 0.633879 19.556 0.151001 19.5047C2.88245 21.0805 6.12674 22 9.6123 22C20.9653 22 27.1733 13.5371 27.1733 6.19787C27.1733 5.95698 27.1675 5.71747 27.1555 5.47933C28.3638 4.6933 29.4068 3.71973 30.2354 2.60431Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2199107019945c15f13672f99d5fe777.svg";
export { ForwardRef as ReactComponent };